const state = {
  tabs: {
     editTabs:[],
     curTabName:'',
     curTabIndex:0
  },
  curPage:{
     name:'',
     title:'',
     icon:'',
     funcKey:'',
     funcName:'',
     roleFuncKey:''
  },
  baseUrl: 'http://jztech.work:8081/wiki'//'http://localhost:18081/wiki'
}
const mutations = {
  set_page:(state,curPage)=>{
    state.curPage=curPage;
  }
}
export default {
  namespaced: true,
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js